import {
  Box,
  Button,
  Image,
  Text,
  TextProps,
  useMultiStyleConfig,
  VStack,
} from "@chakra-ui/react"

import matsnetBtcLogoBlack from "#/assets/matsnet-btc-logo-black.svg"
import CurrencySymbol from "#/shared/components/CurrencySymbol"
import TokenAmountInput from "#/shared/components/TokenAmountInput"
import { useStackMatsnetBtcForm } from "#/shared/hooks"

type StackMatsnetBtcFormProps = {
  totalMats: number
  onSuccessCallback?: (stackedSats?: string, address?: string) => void
}

export default function StackMatsnetBtcForm({
  totalMats,
  onSuccessCallback,
}: StackMatsnetBtcFormProps) {
  const {
    matsToRevoke,
    userFriendlyMatsToRevoke,
    userFriendlySatsToGet,
    hasInputError,
    hasApiError,
    isProcessing,
    handleInputChange,
    errorCallback,
    stackMatsnetBtc,
  } = useStackMatsnetBtcForm(onSuccessCallback)

  const styles = useMultiStyleConfig("TokenAmountInput")

  return (
    <form onSubmit={stackMatsnetBtc}>
      <VStack alignItems="center">
        <Text
          variant="label"
          fontSize="12px"
          fontWeight={500}
          color="primary.black.60"
          fontFamily="riforma.medium"
          alignSelf="start"
        >
          How much would you like to spend?
        </Text>
        <Box position="relative" w="100%" mb={4}>
          <TokenAmountInput
            tokenAmount={userFriendlyMatsToRevoke}
            tokenDecimals={0}
            errorCallback={errorCallback}
            setTokenAmountCallback={handleInputChange}
            maxTokenAmount={totalMats.toString()}
            placeholder="0"
            precisionAmount={0}
            withMaxButton
            maxButtonProps={{ bg: "primary.black.100" }}
            tokenLabel="mats"
            size="md"
            paddingRight="170px"
            checkWalletBalances={false}
          />
        </Box>
        <Text
          w="100%"
          fontSize="12px"
          fontWeight={500}
          fontFamily="riforma.medium"
          color="primary.black.60"
        >
          <CurrencySymbol token="mBTC" />
        </Text>
        <Box position="relative" w="100%" mb="32px">
          <TokenAmountInput
            tokenAmount={userFriendlySatsToGet}
            tokenDecimals={0}
            setTokenAmountCallback={() => {}}
            placeholder="0"
            precisionAmount={0}
            tokenLabel="sats"
            withMaxButton
            size="md"
            paddingRight="170px"
            bg="primary.black.100"
            color="primary.white.100"
            readOnly
          />
          <Image
            src={matsnetBtcLogoBlack}
            position="absolute"
            right="30px"
            top="35px"
            zIndex={10}
          />
        </Box>
        <VStack width="100%" alignItems="center">
          <Button
            variant="primary"
            size="large"
            type="submit"
            width="250px"
            isLoading={isProcessing}
            isDisabled={hasInputError || !matsToRevoke}
          >
            Confirm
          </Button>
          {hasApiError && (
            <Text {...(styles.errorMessage as TextProps)} position="static">
              Something went wrong.
            </Text>
          )}
        </VStack>
      </VStack>
    </form>
  )
}
